const stringUtil = require("../../../utils/string/stringUtil");
const commonUtility = require("../../../utils/domain/commonUtility");
const validator = require("../../../utils/validator/validator");
const translator = require("../../../utils/translator/translator");

export const checkFieldError = (key, value, data = {}) => {
     switch (key) {
          case "name":
               if (stringUtil.isStringNullOrEmpty(value)) {
                    return translator.getLabel("enter_customer_name");
               }
               break;
          case "phoneNumber":
               if (!data.canOrderWithoutCustomerPhoneNumber) {
                    if (stringUtil.isStringNullOrEmpty(value)) {
                         return translator.getLabel("enter_customer_phone_number");
                    }
               }
               const franchisor = commonUtility.getFranchisor();
               if (!stringUtil.isStringNullOrEmpty(value) && stringUtil.isStringNullOrEmpty(validator.formatPhoneNumber(value, franchisor.country))) {
                    return translator.getLabel("phone_number_is_not_correct");
               }
               break;
          case "deliveryDistance":
               if (stringUtil.isStringNullOrEmpty(value)) {
                    return translator.getLabel("enter_delivery_distance");
               }
               if (!validator.isNumeric(value)) {
                    return translator.getLabel("invalid_delivery_distance");
               }
               break;
          case "deliveryCharges":
               if (stringUtil.isStringNullOrEmpty(value)) {
                    return translator.getLabel("enter_delivery_charges");
               }
               if (!validator.isNumeric(value)) {
                    return translator.getLabel("invalid_delivery_charges");
               }
               break;

          case "address":
               if (stringUtil.isStringNullOrEmpty(data[value])) {
                    return translator.getLabel("select_address");
               }
               break;

          default:
               break;
     }

     return null;
};
